import { useId } from 'react';
import PlateSheet from './PlateSheet';
import { GALLERY_LABELS, resolveGalleryLocale } from '../data/portfolio-captions';

/**
 * The parts archive (home): a gallery section whose title and description sit
 * inside the plate sheet, in the cell beside the feature plate, so the
 * section opens on a photograph rather than on another heading.
 * `images` are file names in /public.
 *
 * @param {{
 *   images?: string[],
 *   lang?: 'tr' | 'en' | 'de',
 *   title?: string,
 *   description?: string,
 *   id?: string,
 * }} props
 */
export default function Portfolio({ images = [], lang = 'tr', title, description, id = 'portfolio' }) {
    const headingId = useId();
    const locale = resolveGalleryLocale(lang);
    const heading = title || GALLERY_LABELS[locale].gallery;

    if (!Array.isArray(images) || images.length === 0) return null;

    return (
        <section className="archive" id={id} lang={locale} aria-labelledby={headingId}>
            <div className="container">
                <PlateSheet
                    images={images}
                    lang={lang}
                    label={heading}
                    labelledBy={headingId}
                    layout="archive"
                    head={
                        <header className="section-head archive__title">
                            <h2 id={headingId}>{heading}</h2>
                            {description && <p>{description}</p>}
                        </header>
                    }
                />
            </div>
        </section>
    );
}
